var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState, forwardRef } from 'react';
import { Checkbox, Form, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import Input from '@fp-suite/core-ui/src/components/Input';
import Dropdown from '@fp-suite/core-ui/src/components/Dropdown';
import { usePackingState } from '../hooks';
import { useWeightStationHeartbeat } from '../weight/useWeightStationHeartbeat';
import { WeightStationHeartbeatIndicator } from '../weight/WeightStationHeartbeatIndicator';
import { filterBoxTypesForContainer } from '../shared/boxTypeFilters';
export var BulkPackModal = forwardRef(function (_a, ref) {
    var visible = _a.visible, boxTypes = _a.boxTypes, _b = _a.loading, loading = _b === void 0 ? false : _b, onClose = _a.onClose, onSubmit = _a.onSubmit;
    var t = useTranslation().t;
    var form = Form.useForm()[0];
    var scanInputRef = useRef(null);
    var _c = useState(false), isSubmitting = _c[0], setIsSubmitting = _c[1];
    var _d = usePackingState(), shipmentId = _d.shipmentId, loadPackageWeight = _d.loadPackageWeight;
    var isConfirmLoading = loading || isSubmitting;
    var pendingPrefill = useRef(null);
    // BulkPack creates and closes cartons — filter pallet-only box types out.
    var filteredBoxTypes = useMemo(function () { return filterBoxTypesForContainer(boxTypes, 'carton'); }, [boxTypes]);
    useImperativeHandle(ref, function () { return ({
        prefill: function (params) {
            pendingPrefill.current = params;
        }
    }); }, []);
    var handleSelectAllInputValue = useCallback(function (event) {
        var _a, _b;
        (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.select) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, []);
    var _e = useWeightStationHeartbeat({
        enabled: visible,
        shipmentId: shipmentId,
        shipmentPackageSeqId: undefined,
        loadPackageWeight: loadPackageWeight,
        onWeightReceived: function (weight) {
            form.setFieldsValue({ weight: String(weight) });
        }
    }), lastWeightReceivedAt = _e.lastWeightReceivedAt, weightAgeSeconds = _e.weightAgeSeconds, weightPulseClass = _e.weightPulseClass, hasActiveSource = _e.hasActiveSource, isQzConnected = _e.isQzConnected;
    useEffect(function () {
        if (!visible)
            return;
        var prefill = pendingPrefill.current;
        pendingPrefill.current = null;
        form.setFieldsValue({
            scanId: (prefill === null || prefill === void 0 ? void 0 : prefill.scanId) || '',
            quantity: (prefill === null || prefill === void 0 ? void 0 : prefill.quantity) || 1,
            carton: 1,
            shipmentBoxTypeId: undefined,
            weight: '',
            autoPrintLabels: false
        });
        var timerId = window.setTimeout(function () {
            var _a, _b, _c;
            var inputElement = ((_a = scanInputRef.current) === null || _a === void 0 ? void 0 : _a.input) || scanInputRef.current;
            (_b = inputElement === null || inputElement === void 0 ? void 0 : inputElement.focus) === null || _b === void 0 ? void 0 : _b.call(inputElement);
            (_c = inputElement === null || inputElement === void 0 ? void 0 : inputElement.select) === null || _c === void 0 ? void 0 : _c.call(inputElement);
        }, 0);
        return function () { return window.clearTimeout(timerId); };
    }, [form, visible]);
    var handleSubmit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var values, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (isConfirmLoading)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    setIsSubmitting(true);
                    return [4 /*yield*/, form.validateFields()];
                case 2:
                    values = _b.sent();
                    return [4 /*yield*/, onSubmit({
                            scanId: String(values.scanId || '').trim(),
                            quantity: Math.max(1, Number(values.quantity || 1)),
                            carton: Math.max(1, Number(values.carton || 1)),
                            shipmentBoxTypeId: values.shipmentBoxTypeId,
                            weight: Number(values.weight),
                            autoPrintLabels: Boolean(values.autoPrintLabels)
                        })];
                case 3:
                    _b.sent();
                    form.resetFields();
                    return [3 /*break*/, 6];
                case 4:
                    _a = _b.sent();
                    return [3 /*break*/, 6];
                case 5:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [form, isConfirmLoading, onSubmit]);
    return (_jsx(Modal, __assign({ title: t('Bulk Pack Cartons'), visible: visible, onCancel: function () {
            if (isConfirmLoading)
                return;
            onClose();
        }, onOk: handleSubmit, okText: t('Pack & Close'), confirmLoading: isConfirmLoading, cancelButtonProps: { disabled: isConfirmLoading }, maskClosable: !isConfirmLoading, keyboard: !isConfirmLoading }, { children: _jsxs(Form, __assign({ form: form, layout: 'vertical' }, { children: [_jsx(Form.Item, __assign({ name: 'scanId', label: t('Scan SKU / UPC'), rules: [
                        { required: true, message: t('Please scan a product') },
                        { pattern: /^(?!\s*$).+/, message: t('Please scan a product') }
                    ] }, { children: _jsx(Input, { ref: scanInputRef, title: '', placeholder: t('Scan SKU / UPC'), autoFocus: true, onFocus: handleSelectAllInputValue, onClick: handleSelectAllInputValue }, void 0) }), void 0), _jsx(Form.Item, __assign({ name: 'quantity', label: t('Quantity'), rules: [
                        { required: true, message: t('Please enter quantity') },
                        { pattern: /^[1-9]\d*$/, message: t('Enter a valid quantity') }
                    ] }, { children: _jsx(Input, { title: '', inputType: 'number', placeholder: '1', onFocus: handleSelectAllInputValue, onClick: handleSelectAllInputValue }, void 0) }), void 0), _jsx(Form.Item, __assign({ name: 'carton', label: t('# of Cartons'), rules: [
                        { required: true, message: t('Please enter number of packages') },
                        { pattern: /^[1-9]\d*$/, message: t('Enter a valid package count') }
                    ] }, { children: _jsx(Input, { title: '', inputType: 'number', placeholder: '1', onFocus: handleSelectAllInputValue, onClick: handleSelectAllInputValue }, void 0) }), void 0), _jsx(Form.Item, __assign({ name: 'shipmentBoxTypeId', label: t('Box Type'), rules: [{ required: true, message: t('Please select box type') }] }, { children: _jsx(Dropdown, { searchable: true, placeholder: t('Select Box Type'), data: filteredBoxTypes }, void 0) }), void 0), _jsx(Form.Item, __assign({ name: 'weight', label: t('Package Weight (lbs)'), rules: [
                        { required: true, message: t('Please enter package weight') },
                        { pattern: /^\d+(\.\d+)?$/, message: t('Enter a valid weight') }
                    ] }, { children: _jsx(Input, { title: '', inputType: 'number', placeholder: '0.00', onFocus: handleSelectAllInputValue, onClick: handleSelectAllInputValue }, void 0) }), void 0), _jsx(WeightStationHeartbeatIndicator, { packageSeqId: undefined, lastWeightReceivedAt: lastWeightReceivedAt, weightAgeSeconds: weightAgeSeconds, weightPulseClass: weightPulseClass, hasActiveSource: hasActiveSource, isQzConnected: isQzConnected }, void 0), _jsx(Form.Item, __assign({ name: 'autoPrintLabels', valuePropName: 'checked', style: { marginBottom: 0 } }, { children: _jsx(Checkbox, { children: t('Auto-print carton labels') }, void 0) }), void 0)] }), void 0) }), void 0));
});
export default BulkPackModal;
